export enum Routes {
    SEARCH = '/calling',
    CALL = '/calling/:to/:banId?'
}

export default Routes;
